
  (function(){
    // —— 只作用于当前 section —— //
    const root = document.querySelector('.section-technology-video-template--19166064476202__technology_video_new_83Rmp6');
    if(!root) return;

    // 渐变滚动动画（保持原逻辑，但限定作用域）
    const gradientEls = root.querySelectorAll('.title, .content');
    const windowHeight = window.innerHeight;
    const flag = 0.5, flag2 = 0.4;

    function updateGradientPosition(){
      const scrollTop = window.scrollY;
      const bannerTop = root.offsetTop;
      const progress = Math.min(1, Math.max(0, (scrollTop + windowHeight * flag2 - bannerTop) / (windowHeight * flag)));
      const bgPosition = (1 - progress) * 100;
      gradientEls.forEach(el => el.style.backgroundPositionX = bgPosition + '%');
    }
    function rafScroll(){ if (!root.isConnected) return;
      if (window.scrollY + windowHeight * flag2 > root.offsetTop) updateGradientPosition();
      requestAnimationFrame(rafScroll);
    }
    requestAnimationFrame(rafScroll);

    // —— 只有真正开始播放后才显示 —— //
    const vPC = root.querySelector('.technology-video-pc');
    const vMB = root.querySelector('.technology-video-mb');
    const mql = window.matchMedia('(max-width: 749px)');

    const currentVideo = () => (mql.matches ? vMB : vPC);

    function ensureMutedInline(v){
      if(!v) return;
      v.muted = true; v.setAttribute('muted','');
      v.playsInline = true; v.setAttribute('playsinline','');
      // iOS 有时需要触发一次 play() 才会派发 playing
      try { v.play && v.play().catch(()=>{}); } catch(e){}
    }

    function waitUntilPlaying(v){
      return new Promise(resolve=>{
        if(!v){ resolve(); return; }
        const done = ()=>{ cleanup(); resolve(); };
        const check = ()=>{ if (v.currentTime > 0 && !v.paused && !v.ended) done(); };
        const cleanup = ()=>{
          v.removeEventListener('playing', done);
          v.removeEventListener('timeupdate', check);
          v.removeEventListener('seeked', check);
        };
        v.addEventListener('playing', done, { once:true });
        v.addEventListener('timeupdate', check);
        v.addEventListener('seeked', check);
        check(); // 以防已经在播放
      });
    }

    async function showOnlyWhenPlaying(){
      // Keep the uploaded poster visible while the video buffers or autoplay is unavailable.
      root.classList.add('is-ready');
      const v = currentVideo();
      ensureMutedInline(v);
      await waitUntilPlaying(v);
      root.classList.add('is-ready');    // 真的在播，显示
    }

    showOnlyWhenPlaying();

    // 断点切换：重新等待新视频播放
    function onBreakpoint(){
      root.classList.remove('is-ready');
      showOnlyWhenPlaying();
    }
    if (mql.addEventListener) mql.addEventListener('change', onBreakpoint);
    else if (mql.addListener) mql.addListener(onBreakpoint);
  })();
